import { render, staticRenderFns } from "./MessagesRender.vue?vue&type=template&id=d72f87ca"
import script from "./MessagesRender.vue?vue&type=script&lang=js"
export * from "./MessagesRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports